import { Button, Typography } from "@mui/material";
import { white } from "../../../../theme/colours";

const UserMenuItem = ({ text, icon, onClick }) => {
  const iconStyle = {
    width: "1.25rem",
    color: white,
    fill: white,
    ml: "1.5rem",
  };
  const textStyle = {
    textTransform: "uppercase",
    color: white,
    fontSize: "0.875rem",
    fontWeight: 800,
  };
  const menuStyle = {
    height: "3.5%",
    p: "1rem 2rem",
    justifyContent: icon ? "space-between" : "flex-start",
    "& svg": iconStyle,
  };

  return (
    <Button onClick={onClick} sx={menuStyle}>
      <Typography sx={textStyle}>{text}</Typography>
      {icon ? icon : null}
    </Button>
  );
};

export default UserMenuItem;
